<div class="flex-column middle center">
    <p> {{message}} {{(value*100).toFixed(0)}} % </p>
    <mat-progress-bar mode="determinate" [value]="this.value*100" class="progress"></mat-progress-bar>
</div>
